import React from 'react';
import styles from 'components/Field/Field.scss';

export default class Field extends React.Component {
  constructor() {
    super();
  }

  render() {
    let classes = [styles.field];
    if (this.props.className) {
      classes.push(styles[this.props.className]);
    }

    if (this.props.disabled) {
      classes.push(styles['disabled']);
    }

    let label = this.props.label

    if (this.props.label && this.props.labelPadding) {
      label = React.cloneElement(
        this.props.label,
        { ...label.props }
      );
    }

    let customStyles = null
    if (this.props.fieldPadding) {
      customStyles = {}
      let arr = this.props.fieldPadding.split(' ')
      customStyles['paddingTop'] = arr[0] + 'px';
      customStyles['paddingRight'] = arr[1] + 'px';
      customStyles['paddingBottom'] = arr[2] + 'px';
      customStyles['paddingLeft'] = arr[3] + 'px';
    }

    return (
      <div key={label} className={classes.join(' ')} style={customStyles}>
        {label}
        {this.props.input}
      </div>
    );
  }
}
